import { FC } from "react";
import { useTranslation } from "react-i18next";

import { SVG_LANDINGS } from "@ryde/assets-landings";
import { landingColors } from "@ryde/utils-landings";

import { DownloadsAppButtons } from "../../widgets";

export const StepFinished: FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <SVG_LANDINGS.GreenSVG
        color={landingColors.mintGreen}
        className="v-green-icon"
        aria-hidden="true"
      />
      <h1
        className="landing-title font-size-30"
        style={{ color: landingColors.mintGreen }}
      >
        {t("landing.finished.title3")}
      </h1>

      <div className="divider-bar-label" aria-hidden="true" />

      <div
        className="landing-sub-title font-size-18"
        style={{ color: landingColors.label }}
      >
        {t("landing.finished.subTitle1")}
      </div>

      <div
        className="landing-sub-title font-size-18"
        style={{ color: landingColors.label }}
      >
        {t("landing.finished.subTitle2")}
      </div>

      <div
        className="landing-sub-title font-size-24"
        style={{ color: landingColors.label }}
      >
        <span>
          <b>חשוב: </b>
        </span>
        <span> קוד החברה לצורך הזדהות באפליקציה הוא </span>
        <span>
          <b>justice</b>
        </span>
      </div>

      <div className="divider-bar margin-top-4" aria-hidden="true" />

      <DownloadsAppButtons />
      <div className="landing-container-footer">
        <div className="landing-container-footer-logo" aria-hidden="true"></div>
      </div>
    </>
  );
};
